import React from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { ShareFooter } from "./ShareTray/ShareFooter";

const ShareShoppingList = ({
  closeTray,
  products,
  userId,
  setShow,
  listLink,
}) => {
  const handleCopyLink = async () => {
    try {
      if (products.length === 0) {
        toast.warn("You cannot copy an empty list link.", toastOptions);
        return;
      }
      await navigator.clipboard.writeText(listLink);
      toast.success("Link copied successfully", toastOptions);
    } catch (error) {
      console.error("Failed to copy link: ", error);
    }
  };
  const handleFacebookShare = (url, quote) => {
    // Open Facebook with the share URL and title
    const shareUrl = encodeURIComponent(url);
    const shareQuote = encodeURIComponent(quote);

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = (listLink, content) => {
    // Open WhatsApp with the share URL and title
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${listLink}`)}`
    );
  };
  return (
    <div
      className="d-flex flex-column w-100"
      style={{ paddingTop: "12px", gap: "12px" }}
    >
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "400",
          fontSize: "14px",
          textAlign: "center",
          padding: "0px 18px",
        }}
      >
        Send this shopping list to friends or family so they can view or
        collaborate with you. Choose how you'd like to share.
      </div>
      {userId && (
        <div
          style={{
            cursor: "pointer",
            height: "42px",
            borderRadius: "8px",
            backgroundColor: "#007AFF",
            color: "white",
            margin: "6px 0px",
          }}
          className="d-flex align-items-center justify-content-center"
          onClick={() => {
            if (products?.length === 0) {
              toast.warn(
                "Please add some products in the list before posting",
                toastOptions
              );
            } else {
              setShow(true);
            }
          }}
        >
          <span style={{ fontSize: "16px", fontWeight: "500" }}>
            Post on Lookflock
          </span>
        </div>
      )}
      <hr className="m-0" />
      <ShareFooter
        handleCopyLink={handleCopyLink}
        handleFacebookShare={handleFacebookShare}
        handleWhatsappShare={handleWhatsappShare}
      />
    </div>
  );
};

export default ShareShoppingList;
